import { FastField } from 'formik';
import React from 'react';
import { StyledRadioGroup } from './styled';
import { Radio } from '@chegg-ui/radio';
import { useInitialOrDefaultFieldValue } from '../../hooks/useInitialOrDefaultFieldValue';
export var RadioGroup = function RadioGroup(_ref) {
  var _options$defaultSelec;
  var legend = _ref.legend,
    name = _ref.name,
    options = _ref.options,
    _onChange = _ref.onChange,
    _ref$defaultSelectedI = _ref.defaultSelectedIndex,
    defaultSelectedIndex = _ref$defaultSelectedI === void 0 ? 0 : _ref$defaultSelectedI,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'vertical' : _ref$align,
    dataTest = _ref['data-test'],
    formikFieldName = _ref.formikFieldName;
  useInitialOrDefaultFieldValue(formikFieldName, ((_options$defaultSelec = options[defaultSelectedIndex]) === null || _options$defaultSelec === void 0 ? void 0 : _options$defaultSelec.key) || '');
  return /*#__PURE__*/React.createElement(FastField, {
    name: formikFieldName
  }, function (_ref2) {
    var field = _ref2.field,
      form = _ref2.form;
    var selectedRadioIndex = options.findIndex(function (option) {
      return option.key === field.value;
    });
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StyledRadioGroup, {
      "data-test": dataTest,
      onChange: function onChange(newIndex) {
        form.setFieldValue(formikFieldName, options[newIndex].key);
        _onChange && _onChange(options[newIndex]);
      },
      legend: legend,
      name: name,
      selectedIndex: selectedRadioIndex >= 0 ? selectedRadioIndex : defaultSelectedIndex,
      align: align
    }, options.map(function (option, index) {
      return /*#__PURE__*/React.createElement(Radio, {
        key: index,
        inputId: name + '_' + option.key,
        "data-test": option.key
      }, option.value);
    })));
  });
};